import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class MenuBehaviorSubject {
  constructor(private router: Router) {}

  public menuValue = new BehaviorSubject<any>(null);

  public setMenuValue(value) {
    this.menuValue.next(value);
  }

  public getMenuValue() {
    return this.menuValue;
  }
}
